import map from "lodash/map";
import { useTranslation } from "react-i18next";

const useGetMassagedKPIsList = (rawData: any = []) => {
  const { t } = useTranslation();
  return map(rawData, (dataItem) => {
    return {
      code: dataItem?.code ?? "",
      shortName:
        dataItem?.code === "activationRate:90|30|60"
          ? t(`kpiLabels.activationRate`)
          : t(`kpiLabels.${dataItem?.code}`),
      longName:
        dataItem?.code === "activationRate:90|30|60"
          ? t(`kpiTitles.activationRate`)
          : t(`kpiTitles.${dataItem?.code}`),
      description:
        dataItem?.code
          ? t(`kpiDescription.${dataItem?.code}`)
          : "-",
      type: dataItem?.type ?? "",
    };
  });
};

export default useGetMassagedKPIsList;
